module.exports = __webpack_public_path__ + "img/generate-report.7e2e75fa.svg";